import Dexie from "dexie";

export const db = new Dexie("OfflineDB");

// ❗ Only use this manually when schema breaks
export async function resetDatabase() {
  await db.delete();
  console.log("Database reset complete");
}
// resetDatabase();

db.version(3).stores({
  offlineUsers: "email",
  questionnaires: "[labId+formType], offline, timestamp",
  offlineCertifications: "id,[labId+section],offline,timestamp",

  // ✅ Add name to compound index
  offlineAccreditations: "id,[labId+section+name],offline,timestamp",

  // 🆕 audit summaries
  offlineAuditSummaries: "id, labId, offline, timestamp",

  pendingRequests: "++id, url, method, body, token",
  offlineLabs:
    "id, labName, hpczLicense, updatedAt, createdAt, offline, timestamp",
});